import { PureComponent, ReactNode } from "react";
import InfoCard from "../layout_reuse/InfoCard";
import ChordEditBlastRadiusToggle from "../menu_options/ChordEditBlastRadiusToggle";
import ChordInteractionModeToggle from "../menu_options/ChordInteractionModeToggle";
import ChordLabelModeToggle from "../menu_options/ChordLabelModeToggle";
import ChordSoundArpeggiationToggle from "../menu_options/ChordSoundArpeggiationToggle";
import NoteHideOctaveToggle from "../menu_options/NoteHideOctaveToggle";
import NoteHideSectionToggle from "../menu_options/NoteHideSectionToggle";

import HistoryAutoScrollToggle from "./HistoryAutoScrollToggle";
import "./SettingsMenu.css";

interface Props {}
interface State {}

class SettingsMenuChordHistory extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render(): ReactNode {
    return (
      <div className="settings-menu-wrapper">
        <InfoCard>
          <p>Adjust the visuals and behavior of Note and Chord History</p>
        </InfoCard>
        <InfoCard>
          <h3>Chord Options</h3>
          <div className="settings-several-options">
            <ChordInteractionModeToggle />
            <ChordLabelModeToggle />
            <ChordSoundArpeggiationToggle />
            {/* <ChordSoundOrderToggle /> yuck */}
            <ChordEditBlastRadiusToggle />
          </div>
        </InfoCard>
        <InfoCard>
          <h3>Display Options</h3>
          <div className="settings-several-options">
            <NoteHideSectionToggle />
            <HistoryAutoScrollToggle />
          </div>
        </InfoCard>
        <InfoCard>
          <h3>Note Options</h3>
          <div className="settings-several-options">
            <NoteHideOctaveToggle />
            {/* <NoteOscSawtoothSineToggle /> */}
          </div>
        </InfoCard>
      </div>
    );
  }
}

export default SettingsMenuChordHistory;
